import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('translation-Service');

export class TranslationService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetGlobalizationListsAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/globalization/list', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            }).catch((response) => {
                return response;
            });
    }

    public async RequestUpdateGlobalizationAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/globalization/addandupdate', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            }).catch((response) => {
                return response;
            });
    }

    public async RequestDeleteGlobalizationAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/globalization/delete', params, token)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            }).catch((response) => {
                return response;
            });
    }
}

